import React from "react";
import { Events } from "../../components";
import { MainContainer } from "./Main.styled";

export const Main = () => {
  return (
    <MainContainer>
      <Events />
    </MainContainer>
  );
};
